import React, { useEffect, useState, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import './DummyDashboard.scss';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const EmblaPeek = ({ slides }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'center',
    loop: true,
    skipSnaps: false,
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const scrollTo = useCallback(
    (index) => {
      if (emblaApi) emblaApi.scrollTo(index);
    },
    [emblaApi],
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  // Update selected index on slide change
  useEffect(() => {
    if (!emblaApi) return;

    onSelect();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);

    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  // 🕒 Auto-slide every 4 seconds
  useEffect(() => {
    if (!emblaApi) return;

    const interval = setInterval(() => {
      emblaApi.scrollNext();
    }, 4000);

    return () => clearInterval(interval);
  }, [emblaApi]);

  return (
    <div className='embla-wrapper'>
      <button className='embla-button prev' onClick={scrollPrev}>
        <ChevronLeft />
      </button>

      <div className='embla' ref={emblaRef}>
        <div className='embla__container'>
          {slides.map((slide, idx) => (
            <div
              className={`embla__slide ${idx === selectedIndex ? 'embla__slide--active' : ''}`}
              key={idx}
            >
              <div className='embla__slide__inner'>
                {slide}
                {idx !== selectedIndex && <div className='embla__slide__overlay' />}
              </div>
            </div>
          ))}
        </div>
      </div>

      <button className='embla-button next' onClick={scrollNext}>
        <ChevronRight />
      </button>

      {/* Navigation Dots */}
      <div className='embla__dots'>
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`embla__dot ${idx === selectedIndex ? 'embla__dot--active' : ''}`}
            onClick={() => scrollTo(idx)}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default EmblaPeek;
